import Vue from 'vue'
import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr'
import { getCsrfToken } from '@/libs/axiosIns'

let signalrConnection = null
const connectionCreatedHandlers = new Set()

const createConnection = () => {
  const csrfToken = getCsrfToken()
  const connectionOptions = {
    withCredentials: true,
  }

  if (csrfToken) {
    connectionOptions.headers = { 'X-XSRF-TOKEN': csrfToken }
  }

  return new HubConnectionBuilder()
    .withUrl(window.config.websocketBaseUrl, connectionOptions)
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning) // Only warnings and errors
    .build()
}

export function onSignalrConnectionCreated(handler) {
  connectionCreatedHandlers.add(handler)
  if (signalrConnection) {
    handler(signalrConnection)
  }
}

export async function startSignalrConnection() {
  if (!signalrConnection) {
    signalrConnection = createConnection()
    Vue.prototype.$socket = signalrConnection
    connectionCreatedHandlers.forEach(handler => handler(signalrConnection))
  }

  if (signalrConnection.state === HubConnectionState.Disconnected) {
    try {
      await signalrConnection.start()
      console.log('SignalR connected')
    } catch (error) {
      console.error('SignalR connection failed:', error.message)
    }
  }

  return signalrConnection
}

export async function stopSignalrConnection() {
  const connection = signalrConnection
  signalrConnection = null
  delete Vue.prototype.$socket

  if (connection && connection.state !== HubConnectionState.Disconnected) {
    await connection.stop()
  }
}
